// Public Trust Center index — served at /trust. Renders docs/trust/README.md,
// the curated contents page for the document pack.

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { getTrustIndex } from './trustDocs';
import { TrustLayout } from './TrustLayout';
import { trustMarkdownComponents } from './trustMarkdown';

export default function TrustCenter() {
  const doc = getTrustIndex();

  if (!doc) {
    return (
      <TrustLayout title="Trust Center">
        <p>The Trust Center is temporarily unavailable.</p>
      </TrustLayout>
    );
  }

  return (
    <TrustLayout title={doc.title}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={trustMarkdownComponents}>
        {doc.content}
      </ReactMarkdown>
    </TrustLayout>
  );
}
